module.exports = __webpack_public_path__ + "files/0119fe47ed9daa195d94acd6692e579d.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-120x120.png
// module id = 1247
// module chunks = 76